import { orderMgmtDetailFacade } from '../../../../../business/order-mgmt/infra/store/order-detail';

export function useCountdownToEdit() {
  const { selectStartedAt } = orderMgmtDetailFacade();

  return {
    createdAt: selectStartedAt,
  };
}
